import { Injectable, OnDestroy } from '@angular/core';
import { createStore, select, setProp, setProps, withProps } from '@ngneat/elf';
import { filter, map } from 'rxjs';
import { ActiveAuthentication } from './state/models/active-authentication';
import { ActiveUser } from './state/models/active-user.model';

/**
 * Provides models management for the (partly transient) models of the active authenticating/authenticated identity
 */
@Injectable({ providedIn: 'root' })
export class ActiveAuthenticationStateService implements OnDestroy {
  private store = createStore(
    { name: 'active-authentication' },
    withProps({
      inFlight: false,
      activeIdentitySet: false,
      isSso: false
    } as ActiveAuthentication)
  );

  /**
   * Observable of the current authenticated user (or undefined).
   */
  activeIdentity$ = this.store.pipe(
    select((store: ActiveAuthentication) => store),
    filter((s) => !!s.activeIdentitySet),
    map((s) => s.activeIdentity)
  );

  /**
   * Observable if the remote service is working
   */
  inFlight$ = this.store.pipe(select((s: any) => s.inFlight));

  /**
   * Get the route the user entered the app with
   */
  get landingRoute(): string | null {
    return localStorage.getItem('landingRoute');
  }

  /**
   * Set the route the  user entered the app with
   */
  set landingRoute(landingRoute: string | undefined) {
    if (!landingRoute) {
      localStorage.removeItem('landingRoute');
      return;
    }
    localStorage.setItem('landingRoute', landingRoute);
  }

  /**
   * Get / sets the identity of the current authenticated user
   */
  get activeIdentity(): ActiveUser | undefined {
    return this.store.getValue().activeIdentity;
  }

  set activeIdentity(activeIdentity: ActiveUser | undefined) {
    this.store.update(setProps({ activeIdentity, activeIdentitySet: true }));
  }

  /**
   * Is there are currently signed-in in user with an active my-profile?
   */
  get isAuthenticated(): boolean {
    return this.checkForAuthenticUser(this.activeIdentity);
  }

  /**
   * Indicates an authenticated user.
   */
  private checkForAuthenticUser(userIdentity?:  ActiveUser): boolean {
    return !!userIdentity;
  }

  /**
   * Get / sets whether the remote service is working
   */
  get inFlight(): boolean {
    return this.store.getValue().inFlight;
  }
  set inFlight(inFlight: boolean) {
    this.store.update(setProp('inFlight', inFlight));
  }


  ngOnDestroy() {
    this.store.destroy();
  }
}
